import { OrderedSet as ImmutableOrderedSet } from 'immutable';
const getQuickReplyOptionsFromStagedThreadMessages = messageResults => ImmutableOrderedSet().withMutations(quickReplySet => {
  messageResults.valueSeq().forEach(message => {
    if ('attachments' in message) {
      message.attachments.forEach(attachment => {
        if (attachment['@type'] === 'QUICK_REPLIES' && 'quickReplies' in attachment) {
          attachment.quickReplies.forEach(quickReply => {
            quickReplySet.add(quickReply);
          });
        }
      });
    }
  });
});
export default getQuickReplyOptionsFromStagedThreadMessages;